import { Controller, useFormContext, useWatch } from "react-hook-form";

import { Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { CustomDatePicker } from "@/features/ui";

const ValiditySection = () => {
  const { control } = useFormContext();
  const [validFrom, validTo] = useWatch({
    control,
    name: ["validFrom", "validTo"],
  });

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Masa Berlaku
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Controller
            name="validFrom"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <CustomDatePicker
                {...field}
                label="Tanggal Mulai"
                required
                maxDate={validTo || undefined}
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Controller
            name="validTo"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <CustomDatePicker
                {...field}
                label="Tanggal Berakhir"
                required
                minDate={validFrom || undefined}
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ValiditySection;
